export default {
  mounted(el: HTMLElement, binding: any) {
    handleTypeDirective(el, binding)
  },
  updated(el: HTMLElement, binding: any) {
    handleTypeDirective(el, binding)
  }
}

function handleTypeDirective(el: HTMLElement, binding: any) {
  if (!(el instanceof HTMLInputElement)) return

  const input = el as HTMLInputElement
  const type = binding.value?.type || binding.value || 'text'

  switch (type) {
    case 'number':
      input.addEventListener('input', handleNumberInput)
      input.addEventListener('keypress', preventNonNumeric)
      break
    case 'integer':
      input.addEventListener('input', handleIntegerInput)
      input.addEventListener('keypress', preventNonNumeric)
      break
    case 'float':
      input.addEventListener('input', handleFloatInput)
      input.addEventListener('keypress', allowDecimal)
      break
    case 'alpha':
      input.addEventListener('input', handleAlphaInput)
      input.addEventListener('keypress', allowAlphaOnly)
      break
    case 'alphanumeric':
      input.addEventListener('input', handleAlphanumericInput)
      input.addEventListener('keypress', allowAlphanumericOnly)
      break
    default:
      // Для других типов убираем обработчики
      input.removeEventListener('input', handleNumberInput)
      input.removeEventListener('keypress', preventNonNumeric)
  }
}

// Обработчики для разных типов
function handleNumberInput(e: Event) {
  const input = e.target as HTMLInputElement
  input.value = input.value.replace(/[^\d.-]/g, '')
}

function handleIntegerInput(e: Event) {
  const input = e.target as HTMLInputElement
  input.value = input.value.replace(/[^\d]/g, '')
}

function handleFloatInput(e: Event) {
  const input = e.target as HTMLInputElement
  // Разрешаем цифры и одну точку
  const value = input.value
  const hasDecimal = value.includes('.')
  input.value = value.replace(hasDecimal ? /[^\d.]/g : /[^\d]/g, '')

  // Убираем лишние точки
  const parts = input.value.split('.')
  if (parts.length > 2) {
    input.value = parts[0] + '.' + parts.slice(1).join('')
  }
}

function handleAlphaInput(e: Event) {
  const input = e.target as HTMLInputElement
  input.value = input.value.replace(/[^a-zA-Zа-яА-Я]/g, '')
}

function handleAlphanumericInput(e: Event) {
  const input = e.target as HTMLInputElement
  input.value = input.value.replace(/[^a-zA-Zа-яА-Я0-9]/g, '')
}

// Обработчики keypress
function preventNonNumeric(e: KeyboardEvent) {
  if (!/[\d-]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
    e.preventDefault()
  }
}

function allowDecimal(e: KeyboardEvent) {
  if (!/[\d.-]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
    e.preventDefault()
  }
}

function allowAlphaOnly(e: KeyboardEvent) {
  if (!/[a-zA-Zа-яА-Я]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
    e.preventDefault()
  }
}

function allowAlphanumericOnly(e: KeyboardEvent) {
  if (!/[a-zA-Zа-яА-Я0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
    e.preventDefault()
  }
}
